import { Column } from 'Components/Elements/Layouts';
import { AppState } from 'core/redux/reducers';
import React, { useEffect, useState } from 'react';
// import { hot } from 'react-hot-loader/root'
import { connect, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import BookingNextLoading from '../Components/BookingNextLoading';
import FormStepContainer from '../Components/FormStepContainer';
import Summary from '../Components/Summary';
import { clear } from 'console';
import { useTrans } from 'core/hooks';
import Spinner from 'Components/Spinner';

const mapStateToProps = (state: AppState) => ({
  paymentUrl: state.booking.order.payment_url,
});

const mapDispatchToProps = {};

type TProps = RouteComponentProps<{ step: string }> &
  ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

function Step4() {
  const t = useTrans()
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [showPaymentLink, setShowPaymentLink] = useState(false);
  const { paymentUrl } = useSelector((state: AppState) => ({
    paymentUrl: state.booking.order.payment_url
  }));

  useEffect(() => {
    if (!paymentUrl) {
      return;
    }

    const redirectTimeout = setTimeout(() => {
      setIsRedirecting(true);
      window.location.replace(paymentUrl);
    }, 500);

    return () => {
      clearTimeout(redirectTimeout);
    };
  }, [paymentUrl, isRedirecting]);

  useEffect(() => {
    if (showPaymentLink || !paymentUrl) {
      return;
    }

    const showLinkTimeout = setTimeout(() => {
      setShowPaymentLink(true);
    }, 3000);

    return () => {
      clearTimeout(showLinkTimeout);
    }
  }, [paymentUrl, showPaymentLink]);

  return (
    <FormStepContainer id="book-step4" hideButtons={true}>
      <Column
        className="checkout__content__items checkout--right-border is-flex-mid eb-booking-terms is-flex-direction-column"
        size={['8-tablet']}
      >
        <div style={{ height: 50, width: 50 }} className="has-text-primary">
          <Spinner />
        </div>
        <div>
          {showPaymentLink && (
            <a className="got-to-payment has-text-red" href={paymentUrl} rel="noreferrer">
              {t('go_to_payment')}
            </a>
          )}
        </div>
      </Column>
      <Column
        className="checkout__content__summary checkout__content__items checkout--bg-blue"
        size={'4'}
      >
        <Summary />
      </Column>
    </FormStepContainer>
  );
}

export default Step4;